<script>
  import { onMount } from 'svelte';
  import ApiClient from '$lib/api';

  let users = [];
  let loaded = false;
  const api = new ApiClient();

  async function fetchUsers() {
    loaded = false;
    try {
      const res = await api.get('/api/users');

      if (res.success) {
        users = res.users;
      } else {
        console.error('API error34:', res.error);
      }
    } catch (err) {
      console.error('Fetch error12:', err);
    } finally {
      loaded = true;
    }
  }

  onMount(() => {
    fetchUsers();
  });
</script>

<div class="max-w-3xl mx-auto p-4">
  <h1 class="text-2xl font-bold mb-4 text-center">User List</h1>

  {#if !loaded}
    <div class="text-center text-gray-500">Loading...</div>
  {:else if users.length === 0}
    <div class="text-center text-red-500">No users found.</div>
  {:else}
    <div class="overflow-x-auto bg-white rounded-lg shadow">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          {#each users as user, i}
            <tr class="hover:bg-gray-100">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{i + 1}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.name}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-blue-600">{user.email}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  {/if}
</div>
